<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden">

  <!-- Background Video -->
 <img
  src="https://empirewebvideos.s3.us-east-1.amazonaws.com/Probabase_bolide/black-businesswoman-addressing-team-at-meeting-lo-2026-01-05-06-27-01-utc.jpg" 
  class="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
  alt="Hero image"
/>

  <!-- Extra-dim Overlay -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

  <!-- =========================
       CONTENT LAYER
  =========================== -->
  <div class="container position-relative z-1 min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center align-items-center w-100">

      <!-- =========================
          CREATE NEW PASSWORD
      =========================== -->
      <div
        class="glass-card p-4 p-md-5 rounded-4 shadow-sm
               col-12 col-sm-8 col-md-6 col-lg-5 col-xl-5 mx-auto"
      >

        <!-- Logo -->
        <div class="text-center mb-3">
          <router-link
            to="/"
            class="auth-logo mb-2 text-decoration-none d-inline-block"
            aria-label="Bolide Home"
          ></router-link>

        </div>

        <!-- Heading -->
        <h3 class=" mb-1 text-center text-white">
          Create New Password
        </h3>

        <p class="text-center text-white-50 mb-4 text-sm">
          Enter your new password below.
        </p>

        <!-- Error -->
        <div 
          v-if="error_message" 
          class="alert alert-danger alert-dismissible fade show rounded-3"
          role="alert"
        >
          {{ error_message }}
          <button 
            type="button" 
            class="btn-close"
            @click="error_message = ''"
          ></button>
        </div>

        <!-- Success -->
        <div 
          v-if="success_message" 
          class="alert alert-success alert-dismissible fade show rounded-3"
          role="alert"
        >
          {{ success_message }}
          <button 
            type="button" 
            class="btn-close"
            @click="success_message = ''"
          ></button>
        </div>

        <!-- Loading -->
        <div v-if="is_loading" class="text-center mb-3">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-white-50">Updating password...</span>
        </div>

        <!-- ==========================
              RESET PASSWORD FORM
        =========================== -->
        <form @submit.prevent="submitNewPassword" v-if="!is_loading">

          <!-- New Password -->
          <div class="mb-3">
            <label class="form-label text-xs text-white-50">New Password</label>
            <div class="position-relative overflow-hidden rounded-3">
              <input
                v-model="password"
                :type="password_input_type"
                class="form-control form-control-sm rounded-3 pe-5
                      bg-transparent text-white border-secondary placeholder-white"
                placeholder="Enter password"
                required
              />
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="mb-3">
            <label class="form-label text-xs text-white-50">Confirm Password</label>
            <div class="position-relative overflow-hidden rounded-3">
              <input
                v-model="confirmPassword"
                :type="password_input_type"
                class="form-control form-control-sm rounded-3 pe-5
                      bg-transparent text-white border-secondary placeholder-white"
                placeholder="Re-enter password"
                required
              />
              <button
                type="button"
                class="btn btn-primary position-absolute top-50 end-0 translate-middle-y text-white-50 px-2"
                @click="toggle_change_password_type"
                :aria-label="password_input_type === 'password' ? 'Show password' : 'Hide password'"
              >
                <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </button>
            </div>
          </div>

          <button 
            class="btn btn-primary w-100 rounded-3 fw-light text-xs mb-3"
          >
            Save New Password
          </button>

          <p class="text-center text-white-50 text-xs mb-0">
            Remember your password?
            <router-link to="/login" class="text-decoration-none text-primary">
              Login
            </router-link>
          </p>

        </form>

      </div>

    </div>
  </div>
</div>
